import { usePermissions } from 'react-admin'
import type { Permissions } from '../types/apiTypes'

/** True when the access token has any of the scopes. */
export const useHasScope = (...scopes: string[]): boolean => {
  const { permissions } = usePermissions<Permissions>()
  return !!permissions?.scopes?.some(scope => scopes.includes(scope))
}
